import { render, staticRenderFns } from "./ExistingPopulasi.vue?vue&type=template&id=ced1dede&"
import script from "./ExistingPopulasi.vue?vue&type=script&lang=js&"
export * from "./ExistingPopulasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports